var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardCheckDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "a/icons/16/clipboard-check-dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a/icons/16/clipboard-check-dark",
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.5, 1)",
    stroke: "color(display-p3 0.000 0.000 0.000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2105263,6.04421053 L14.2105263,12.6315789 C14.2105263,13.5036075 13.5036075,14.2105263 12.6315789,14.2105263 L1.57894737,14.2105263 C0.706918816,14.2105263 0,13.5036075 0,12.6315789 L0,1.57894737 C0,0.706918816 0.706918816,0 1.57894737,0 L11.3242105,0",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "4.73684211 6.31578947 7.10526316 8.68421053 15 0.789473684"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardCheckDark);
export default __webpack_public_path__ + "static/media/clipboard-check-dark.0dde4c946c60721bf4b7d46514f98ab1.svg";
export { ForwardRef as ReactComponent };